/**
 * LocationWarningBanner Component
 *
 * Displays a warning when contractor's location is not set
 * Explains that the profile won't appear in search results
 */

'use client';

import { Typography } from '@/src/shared/ui/typography/Typography';
import { Icon } from '@/src/shared/ui/icons/Icon';

export interface LocationWarningBannerProps {
  message: string;
  onDismiss?: () => void;
}

export function LocationWarningBanner({ message, onDismiss }: LocationWarningBannerProps) {
  return (
    <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-6">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 mt-0.5 text-amber-600 text-xl">
          📍
        </div>
        <div className="flex-1">
          <Typography variant="body" weight="semibold" className="text-amber-800 mb-1">
            Location not set
          </Typography>
          <Typography variant="bodySm" className="text-amber-700">
            {message}
          </Typography>
        </div>
        {onDismiss && (
          <button
            onClick={onDismiss}
            className="flex-shrink-0 p-1 hover:bg-amber-100 rounded-full transition-colors"
            aria-label="Dismiss warning"
          >
            <Icon name="x" size="sm" className="text-amber-600" />
          </button>
        )}
      </div>
    </div>
  );
}
